<template>
    <div class="flex float-left vertical-center">
        <!-- <vs-button :disabled="isDisabled" v-bind:id="'btn-row-detail-'+row_number" v-if="readShow" size="small" @click="readRecord"
                   color="primary"
                   class="mr-2">View Submerchant ({{ submerchant_count }})</vs-button>
                    -->
        <div v-if="this.submerchant_count > 0">
          <vs-avatar color="primary" @click="readRecord" v-bind:text="submerchant_count_text" style="margin-top: 25px;"/>
        </div>
        <div v-else>
          <vs-avatar text="NO" style="margin-top: 25px;"/>
        </div>
    </div>
</template>

<script>
    import Vue from "vue";
    import swal from "sweetalert2";

    export default Vue.extend({
        name: "ActionTableShowSubmerchantAgGridComponent",
        data() {
            return {
                isDelete: false,
                show:true,
                readShow:false,
                row_number: 0,
                isDisabled: true,
                submerchant_count : 0,
                submerchant_count_text : "N/A",
                statusText: "Merchant has 0 submerchant",
            }
        },
        methods: {
            readRecord() {
              if (this.submerchant_count<=0) {
                swal.fire({
                  type: 'error',
                  title: 'Failed!',
                  text: "Merchant has no submerchant"
                })
                return false
              }
              this.$root.$emit("read-from-ActionTableAgGridComponent", this.params.data)
            },
            created() {

            }
        },
        created() {
            this.submerchant_count = this.params.data.submerchant_count
            if (this.params.data.submerchant_count>0) {
              this.isDisabled=false
              this.statusText="Merchant has "+this.params.data.submerchant_count+" submerchant"
              this.submerchant_count_text = String(this.submerchant_count)
            }
            this.row_number = this.params.data.no
            this.isDelete = this.params.isDelete

            if (this.params.readShow) this.readShow = true

            const role = localStorage.getItem("userRole")
            const merchant = JSON.parse(localStorage.getItem("userInfo")).merchant

            if (!(role == 'root' || role == 'administrator' || role == 'aino_cc' || role == 'merchant_admin') ) {
                this.show=false
            }else{
                if ((merchant.id !== undefined && merchant.id !== this.params.value) &&  parseInt(this.params.data.depth) <= parseInt(merchant.depth)) this.show= false;
            }
        },
    })
</script>

<style scoped>
    .vertical-center {
        margin: 0;
        position: absolute;
        top: 50%;
        -ms-transform: translateY(-50%);
        transform: translateY(-50%);
    }
</style>